export default {
	id: "macbook",
	title: "Macbook",
	company: "Apple",
	styles: [
		{
			title: "normal",
			pos: ["7.5%", "12.4%", "11%", "12.4%"],
			colors: [
				{title: "Gold", hex: "#DBC5AB", img: require("./original/gold.png")},
				{
					title: "Silver",
					hex: "#D5D2CF",
					img: require("./original/silver.png")
				},
				{
					title: "Space Grey",
					hex: "#9D9D9D",
					img: require("./original/space-grey.png")
				}
			]
		},
		{
			title: "flat",
			pos: ["7.2%", "12.2%", "10.8%", "12.2%"],
			colors: [
				{title: "Gold", hex: "#DBC5AB", img: require("./flat/gold.svg")},
				{title: "Silver", hex: "#D5D2CF", img: require("./flat/silver.svg")},
				{
					title: "Space Grey",
					hex: "#9D9D9D",
					img: require("./flat/space-grey.svg")
				}
			]
		}
	]
};
